/* import __COLOCATED_TEMPLATE__ from './project-team-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();